<template>
  <div class="card bg-base-100 p-4 rounded-lg flex flex-col gap-4 shadow-xl">
    <!-- <div class="flex items-center">
      <button class="btn btn-ghost btn-sm" @click="isPromptExpanded = !isPromptExpanded">
        <i class="mdi" :class="isPromptExpanded ? 'mdi--chevron-up' : 'mdi--chevron-down'"></i>
      </button>
      <h2 class="card-title text-lg">Prompt</h2>
    </div> -->

    <div
      class="transition-all duration-300 ease-in-out overflow-hidden"
      :style="{
        maxHeight: isPromptExpanded ? '1000px' : '0px',
        opacity: isPromptExpanded ? 1 : 0,
      }"
    >
      <!-- Tab Buttons -->
      <!-- <div class="tabs tabs-boxed w-full">
        <a
          class="tab flex-1"
          :class="{ 'tab-active': activeTab === 'positive' }"
          @click="activeTab = 'positive'"
          >你想画什么</a
        >
        <a
          class="tab flex-1"
          :class="{ 'tab-active': activeTab === 'negative' }"
          @click="activeTab = 'negative'"
          >不想画什么</a
        >
      </div> -->

      <!-- Prompt Inputs -->
      <div class="flex flex-col mt-4">
        <!-- Fixed Prompts -->
        <!-- Positive Prompts (shown when activeTab is 'positive') -->
        <!-- <div v-show="activeTab === 'positive'"> -->
        <div>
          <textarea
            v-model="avatarStore.positivePrompt"
            placeholder="描述一下你想画什么"
            class="textarea textarea-bordered w-full"
            rows="4"
          ></textarea>
        </div>
        <!-- </div> -->

        <!-- Negative Prompts (shown when activeTab is 'negative') -->
        <!-- <div v-show="activeTab === 'negative'">
          <div>
            <textarea
              v-model="avatarStore.negativePrompt"
              placeholder="描述一下你不想画什么"
              class="textarea textarea-bordered w-full"
              rows="4"
            ></textarea>
          </div>
        </div> -->

        <!-- Extracted Image Prompts (shown for both tabs) -->
        <div>
          <!-- <label class="label">
            <div>
              <span class="label-text font-medium">提取的图像提示</span>
              <span class="label-text-alt block text-base-content/70 mt-1">Click on any prompt to add it to your {{
                activeTab === 'positive' ? 'Positive' : 'Negative' }} Fixed Prompt</span>
            </div>
          </label>
          <div v-if="positiveDynamicPrompt"
            class="bg-base-200 rounded-lg p-2 min-h-[4rem] flex flex-wrap gap-2 max-h-[80px] overflow-y-auto">
            <button v-for="prompt in extractedPrompts" :key="prompt" @click="appendToFixedPrompt(prompt)" class="badge"
              :class="[
                isPromptInFixed(prompt) ? 'badge-primary' : 'badge-neutral hover:badge-primary',
                'transition-colors cursor-pointer'
              ]">
              {{ prompt }}
              <i v-if="isPromptInFixed(prompt)" class="iconify mdi--close-circle text-xs ml-1"></i>
            </button>
          </div>
          <div v-else class="text-base-content/50 bg-base-200 rounded-lg p-4 min-h-[4rem] text-center text-xs">
            After generating an image, the recognized elements and details will be displayed here as clickable tags
          </div> -->
        </div>
      </div>
      <!-- 
      <div class="form-control w-full">
        <label class="label">
          <span class="label-text"
            >变换强度: {{ strength }}
            <span class="text-base-content/70 label-text-alt">{{
              intensityLevels[Math.round(strength * 10) - 1]
            }}</span></span
          >
        </label>
        <input
          type="range"
          v-model="strength"
          min="0"
          max="1"
          step="0.1"
          class="range"
        />
      </div> -->

      <!-- <div class="form-control w-full">
        <label class="label">
          <span class="label-text"
            >保留线条强度: {{ lineWeight }}
            <span class="text-base-content/70 label-text-alt">{{
              preservationLevels[Math.round(lineWeight * 10) - 1]
            }}</span></span
          >
        </label>
        <input
          type="range"
          v-model="lineWeight"
          min="0"
          max="1"
          step="0.1"
          class="range"
        />
      </div> -->
    </div>

    <button
      @click="handleGenerateAvatar"
      class="btn btn-primary"
      :disabled="isGenerating"
    >
      <span v-if="isGenerating" class="loading loading-spinner"></span>
      {{ isGenerating ? "正在绘制..." : "绘制" }}
    </button>

    <div v-if="isGenerating" class="w-full">
      <div class="w-full bg-base-200 rounded-full h-2.5 dark:bg-base-300">
        <div
          class="bg-primary h-2.5 rounded-full transition-all duration-[60ms] ease-linear"
          :style="{ width: `${progress}%` }"
        ></div>
      </div>
      <div class="text-sm text-center mt-1 text-base-content/70">
        <template v-if="isWaitingForImage">
          请稍等，我们正在完善您的图像...
        </template>
        <template v-else>
          正在完善您的图像... {{ Math.round(progress) }}%
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PixelCanvas from "@/features/draw/components/canvas/PixelCanvas.vue";
import { ref } from "vue";
import { useImageProcessing } from "@/features/draw/composables/useImageProcessing";
import { useAvatarStore } from "@/features/draw/stores/useAvatarStore";
import api from "@/modules/api";
import { createOneAvatarDraw } from "@/features/draw/api";
import { useMate } from "@/stores/mate";
import { useGlobalUser } from "@/stores/globalUser";

const props = defineProps<{
  canvasRef: InstanceType<typeof PixelCanvas> | null;
  selectedLayerId: number;
}>();

const emit = defineEmits<{
  "update:dynamicPrompt": [value: string];
  "update:strength": [value: number];
  "update:lineWeight": [value: number];
  "generate-layer": [
    data: { layerId: number; pixels: Uint32Array; forceAddToHistory?: boolean }
  ];
  "merge-colors": [threshold: number, forceAddToHistory?: boolean];
}>();

const avatarStore = useAvatarStore();

// 移除computed属性，直接使用store中的值

const latestRawImageUrl = defineModel<string>("latestRawImageUrl", {
  required: true,
  default: "",
});

const strength = defineModel<number>("strength", { required: true });
const lineWeight = defineModel<number>("lineWeight", { required: true });

const intensityLevels = [
  "星尘波动", // 数值为0.1
  "萤火微光", // 数值为0.2
  "初樱绽放", // 数值为0.3
  "虹色跃动", // 数值为0.4
  "幻境穿梭", // 数值为0.5
  "量子绘染", // 数值为0.6
  "次元突破", // 数值为0.7
  "极彩风暴", // 数值为0.8
  "超新星爆", // 数值为0.9
  "终焉创世", // 数值为1
];

const preservationLevels = [
  "初心印记", // 数值为0.1
  "时光琥珀", // 数值为0.2
  "结界守护", // 数值为0.3
  "灵魂回响", // 数值为0.4
  "记忆刻印", // 数值为0.5
  "永恒契约", // 数值为0.6
  "神谕加护", // 数值为0.7
  "维度锚定", // 数值为0.8
  "因果律锁", // 数值为0.9
  "轮回不灭", // 数值为1
];

// State
const isGenerating = defineModel<boolean>("isGenerating", {
  required: true,
  default: false,
});
const rawImageUrl = ref<string | undefined>(undefined);
const progress = defineModel<number>("progress", {
  required: true,
  default: 0,
});
const progressInterval = ref<ReturnType<typeof setInterval> | null>(null);
const isWaitingForImage = ref(false);
const activeTab = ref("positive");
const selectedStyle = ref("sketch");
const isPromptExpanded = ref(true);

const startProgress = () => {
  progress.value = 0;
  isWaitingForImage.value = false;
  const duration = 18000; // 18 seconds
  const updateInterval = 50; // Update every 50ms for smoother animation
  const steps = duration / updateInterval;
  const increment = 100 / steps; // Much slower increment

  progressInterval.value = window.setInterval(() => {
    if (progress.value < 35) {
      // Phase 1: Normal speed up to 35%
      progress.value = Math.min(35, progress.value + increment);
    } else if (progress.value >= 35 && progress.value < 65) {
      // Phase 2: Slower speed up to 65%
      progress.value = Math.min(65, progress.value + increment * 0.7);
    } else if (progress.value >= 65 && progress.value < 100) {
      // Phase 3: Even slower to 85%
      progress.value = Math.min(100, progress.value + increment * 0.4);
      if (progress.value >= 100) {
        isWaitingForImage.value = true;
      }
    }
  }, updateInterval);
};

const stopProgress = () => {
  if (progressInterval.value) {
    window.clearInterval(progressInterval.value);
    progressInterval.value = null;
  }

  return new Promise<void>((resolve) => {
    const finalDuration = 800; // 800ms for final animation
    const startProgress = progress.value;
    const endProgress = 100;

    const easeOutQuart = (x: number): number => {
      return 1 - Math.pow(1 - x, 4);
    };

    const startTime = performance.now();
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progressRatio = Math.min(elapsed / finalDuration, 1);
      const easedProgress = easeOutQuart(progressRatio);

      const currentValue =
        startProgress + (endProgress - startProgress) * easedProgress;
      progress.value = Math.min(100, currentValue);

      if (progress.value < 100) {
        requestAnimationFrame(animate);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(animate);
  });
};

const handleGenerateAvatar = async () => {
  if (!props.canvasRef) return;

  isGenerating.value = true;
  avatarStore.isControlsVisible = false;
  avatarStore.guidUserString = "";

  startProgress();

  let generatedData: {
    filePrompt: string;
    avatar: string;
    pixels: Uint32Array;
  } | null = null;

  try {
    // Fill transparent areas with white color
    const tempCanvas = document.createElement("canvas");
    const pngDataUrl = props.canvasRef.exportToPng();
    if (!pngDataUrl) return;

    const img = new Image();
    img.src = pngDataUrl;

    await new Promise((resolve) => {
      img.onload = resolve;
    });

    tempCanvas.width = img.width;
    tempCanvas.height = img.height;
    const ctx = tempCanvas.getContext("2d");
    if (!ctx) return;

    // Fill with white first
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

    // Draw the image
    ctx.drawImage(img, 0, 0);

    // 上传
    const processedDataUrl = tempCanvas.toDataURL("image/png");
    if (!processedDataUrl) return;
    const imageResponse = await fetch(processedDataUrl);
    const imageBlob = await imageResponse.blob();
    const mateStore = useMate();
    const result = await api.uploadMedia(
      0,
      new File([imageBlob], "avatar.png", { type: "image/png" }),
      mateStore.currentMate?.id
    );
    const media = result?.item;

    const genRes = await createOneAvatarDraw({
      referenceMediaId: media.id,
      positivePrompt: avatarStore.positivePrompt,
      negativePrompt: avatarStore.negativePrompt,
      style: selectedStyle.value,
      strength: Number(strength.value),
      lineWeight: Number(lineWeight.value),
    });

    const userStore = useGlobalUser();
    await userStore.refreshUser();

    // Process the image using our composable
    const { createImageFromUrl } = useImageProcessing();

    const processedImage = await createImageFromUrl(
      genRes.item.resultMedia?.url || ""
    );

    // Store the generated data
    generatedData = {
      filePrompt: avatarStore.positivePrompt || "",
      avatar: genRes.item.resultMedia?.url || "", // Store the base64 image instead of the blob URL
      pixels: processedImage.pixels,
    };
  } catch (error) {
    console.error("Error generating avatar:", error);
  } finally {
    // Wait for progress animation to complete
    await stopProgress();

    // Update UI only after progress animation is complete
    if (generatedData) {
      // Store the raw image URL
      rawImageUrl.value = generatedData.avatar;

      // Emit events to update the layer
      emit("generate-layer", {
        layerId: props.selectedLayerId,
        pixels: generatedData.pixels,
        forceAddToHistory: false,
      });

      latestRawImageUrl.value = generatedData.avatar;

      // Automatically merge colors with threshold 5
      // emit("merge-colors", 5, false);

      // Add to history with all data
      avatarStore.addHistoryEntry({
        prompt: avatarStore.positivePrompt,
        strength: strength.value,
        lineWeight: lineWeight.value,
        imageUrl: generatedData.avatar,
        extractedPrompt: generatedData.filePrompt,
      });
    }

    isGenerating.value = false;

    avatarStore.finishGuidUserDraw = true;
  }
};

defineExpose({
  updateFromHistory: (historyData: {
    prompt: string;
    strength: number;
    lineWeight: number;
  }) => {
    // Only update the dynamic prompt, keep the fixed prompt unchanged
    avatarStore.positivePrompt = historyData.prompt;
    strength.value = historyData.strength;
    lineWeight.value = historyData.lineWeight;
  },
  handleGenerateAvatar,
});
</script>
